import { render } from "./indexDarklayout.vue?vue&type=template&id=1578ceae"
import script from "./indexDarklayout.vue?vue&type=script&lang=js"
export * from "./indexDarklayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__